import { Colors } from 'src/components/theme'

export const gradientsDefaultColor = 'rgba(0,0,0,255)'
export const gradientsDefaultTransparent = 'rgba(0,0,0,0)'
export const gradientsAmount = 4
export const gradientsLevels = 3
export const gradientsDistributionList = [33, 66]
export const gradientsList = [
  [Colors.tradeAreaOneTertiary, Colors.tradeAreaOneSecondary, Colors.tradeAreaOnePrimary],
  [Colors.tradeAreaTwoTertiary, Colors.tradeAreaTwoSecondary, Colors.tradeAreaTwoPrimary],
  [Colors.tradeAreaThreeTertiary, Colors.tradeAreaThreeSecondary, Colors.tradeAreaThreePrimary],
  [Colors.tradeAreaFourTertiary, Colors.tradeAreaFourSecondary, Colors.tradeAreaFourPrimary],
]

export const gradientsListContrast = [
  [Colors.redDark, Colors.yellowDark, Colors.tealDark],
  [Colors.redDark, Colors.yellowDark, Colors.tealDark],
  [Colors.redDark, Colors.yellowDark, Colors.tealDark],
]

export const TRIAD_COLORS = [Colors.redDark, Colors.yellowDark, Colors.tealDark]

export const gradientsIntersectionColor = Colors.tradeAreaIntersection
export const hexagonMapOpacity = 0.8
